import React, { Component, Fragment } from 'react';
import { hot } from 'react-hot-loader';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { Label, Col, Row, FormGroup } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { Creatable } from 'react-select';
import '../CreateTemplate.scss';

import { UploadDropzone, ErrorMessage, CloseButton } from '../../..';
import { GET_COMPANY_DOCUMENT_CATEGORIES, LOADING_PROP_TYPE } from '../../../../modules';
import { MAX_DOC_CATEGORY_LENGTH } from '../../../../constants';
import { esignProductTierNames } from '../../../../constants/esignProductTierNames';

const formatGroupLabel = data => (
  <FormattedMessage id={data.label} />
);

class UploadTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOnboardingDoc: false,
      isVisible: undefined,
    };
    this.toggleVisibility = this.toggleVisibility.bind(this);
  }

  toggleVisibility(unCheck = false) {
    if (unCheck || this.state.isVisible) {
      this.setState({ isVisible: undefined });
      document.getElementById('visibility').checked = false;
    } else {
      this.setState({ isVisible: true });
      document.getElementById('visibility').checked = true;
    }
  }

  render() {
    const {
      onDrop,
      onError,
      hasFile,
      loading,
      groupedCategoryList,
      functions,
      selectedCompany,
      onClose,
      values,
      touched,
      errors,
    } = this.props;

    const maxCategoryLength = MAX_DOC_CATEGORY_LENGTH;
    const companyIsSimpleSign = selectedCompany.esignatureProductTier.name === esignProductTierNames.SIMPLESIGN;
    const companyIsLegacy = selectedCompany.isEsignatureLegacyCompany;
    const configureTemplateClasses = ['reduced-text'];
    if (companyIsSimpleSign) {
      if (companyIsLegacy) {
        if (!this.state.isOnboardingDoc) {
          configureTemplateClasses.push('disabled-row', 'text-muted');
        }
      } else {
        configureTemplateClasses.push('d-none');
      }
    }
    return (
      <Fragment>
        {/* we use a negative margin on the header so that the bottom border extends all the way to the edge of the container */}
        <div className="modal-header pt-0 pb-4 mx-n4 px-4">
          <p className="font-weight-light h4 mb-0">
            <FormattedMessage id="ADD_DOCUMENT" />
          </p>
          <CloseButton onClick={() => onClose(values.title || values.category || hasFile)} />
        </div>
        <Row className="py-3">
          <Col>
            <FormGroup>
              <UploadDropzone onDrop={onDrop} onError={onError} iconSize="4rem" />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label className="required" for="title"><FormattedMessage id="TITLE" /></Label>
              <Field
                name="title"
                type="text"
                className={errors.title && touched.title ? 'form-control is-invalid' : 'form-control'}
                placeholder="Title"
                defaultValue=""
              />
              <ErrorMessage errorText={errors.title} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label for="category"><FormattedMessage id="CATEGORY" /></Label>
              <Field
                name="category"
                render={({ form }) => (
                  <Creatable
                    name="category"
                    options={groupedCategoryList}
                    value={(
                            form.values.category ?
                            { value: form.values.category, label: form.values.category } :
                            null
                          )}
                    formatGroupLabel={formatGroupLabel}
                    placeholder="Select a category"
                    classNamePrefix="react-select-container"
                    className={
                              errors.category && touched.category
                                ? 'form-control is-invalid p-0'
                                : 'react-select-container form-control p-0 mb-0 border-0'
                              }
                    menuPlacement="top"
                    onBlur={() => form.setFieldTouched('category', true, true)}
                    onChange={option => (option ? form.setFieldValue('category', option.value) : form.setFieldValue('category', ''))}
                    onInputChange={input => input.substr(0, maxCategoryLength)}
                    isLoading={loading[GET_COMPANY_DOCUMENT_CATEGORIES] === 'loading'}
                    isValidNewOption={(inputValue, selectValue, selectOptions) => (
                            !(
                              !inputValue ||
                              selectOptions.map(category => category.options.some(e => e.label === inputValue)).some(e => e) ||
                              selectValue.some(e => e.label === inputValue)
                            )
                          )
                          }
                    styles={{
                            singleValue: provided => ({ ...provided, whiteSpace: 'pre !important' }),
                            menu: provided => ({
                              ...provided,
                              whiteSpace: 'pre !important',
                              maxHeight: '20vh',
                              overflow: 'scroll',
                            }),
                            menuList: provided => ({ ...provided, maxHeight: '20vh' }),
                          }}
                    onMenuScrollToBottom={(functions.getCategories)}
                  />
                      )}
              />
              <ErrorMessage errorText={errors.category} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col className="text-muted">
            <FormattedMessage id="YOU_CAN_SELECT_SIGNATURE_OPTIONS" />
          </Col>
        </Row>
      </Fragment>
    );
  }
}

UploadTemplate.propTypes = {
  onDrop: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  hasFile: PropTypes.bool.isRequired,
  loading: LOADING_PROP_TYPE.isRequired,
  onClose: PropTypes.func.isRequired,
  functions: PropTypes.shape({
    getCategories: PropTypes.func,
  }).isRequired,
  groupedCategoryList: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  selectedCompany: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    esignatureProductTier: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
    isEsignatureLegacyCompany: PropTypes.bool,
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  values: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  errors: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  touched: PropTypes.any.isRequired,
};

export default hot(module)(UploadTemplate);



// WEBPACK FOOTER //
// ./src/components/Forms/CreateTemplate/UploadTemplate/UploadTemplate.jsx